import { render, staticRenderFns } from "./buyCountInfo.vue?vue&type=template&id=6537c8fa&"
import script from "./buyCountInfo.vue?vue&type=script&lang=js&"
export * from "./buyCountInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports